module.exports = __webpack_public_path__ + "static/lemonade-api-63a3c6543583e15ef5639e1b814570b9.mp4";